export const productListTabs =[
    {
     id:'1',
     tabName : 'Items',
     url:'/productList/items',
    },
    {
    id:'2',   
    tabName : 'Beverages',
    url:'/productList/beverages',
    },
    {
    id:'3',
    tabName : 'Desserts',
    url:'/productList/desserts',
    },
    {
    id:'4',
    tabName : 'Stations',
    url:'/productList/stations',
    },
    {
    id:'5',
    tabName : 'Combos',
    url:'/productList/combos',
    },
    {
    id:'6',    
    tabName : 'Archive',
    url:'/productList/Archieve',
    },
]